export default __webpack_public_path__ + "static/media/atraso-upgas.13b254a4.ogg";